import { createSlice } from '@reduxjs/toolkit';

import songsDataRaw from 'data/songs.json';
import albumDataRaw from 'data/albums.json';
import peopleDataRaw from 'data/people.json';

import { Song, PeopleState, PeopleDetails, Album } from 'interfaces';

const initialStateDefault: PeopleState = {
  peopleDetails: {
    id: null,
    name: null,
    isMember: false
  },
  songArt: {
    lyrics: [],
    music: [],
    arrangement: [],
    production: []
  }
};

const peopleData: PeopleDetails[] = peopleDataRaw as unknown as PeopleDetails[];
const songsData: Song[] = songsDataRaw as unknown as Song[];
const albumsData: Album[] = albumDataRaw as unknown as Album[];

const peopleSlice = createSlice({
  name: 'people',
  initialState: initialStateDefault,
  reducers: {
    getPeopleDetails (state, action) {
      const { peopleId, peopleName } = action.payload;

      const peopleDetails = peopleData.filter((el) => el.id === peopleId)[0];

      const getSongAllDetails = (song) => {
        const albumDetails = albumsData.filter((album) => song.albumId === album.id)?.[0];
        return {
          ...song,
          albumName: albumDetails?.name,
          albumEnglishName: albumDetails?.englishName,
          releaseDate: albumDetails?.releaseDate,
        }
      };

      const songArtLyrics = songsData
        .filter((el) => el.songDetails?.lyrics?.indexOf(peopleId) !== -1
          || peopleDetails?.isMember && el.songDetails?.lyrics?.indexOf('one_ok_rock') !== -1)
        .map((el) => getSongAllDetails(el));

      const songArtMusic = songsData
        .filter((el) => el.songDetails?.music?.indexOf(peopleId) !== -1
          || peopleDetails?.isMember && el.songDetails?.music?.indexOf('one_ok_rock') !== -1)
        .map((el) => getSongAllDetails(el));

      const songArtArrangement = songsData
        .filter((el) => el.songDetails?.arrangement?.indexOf(peopleId) !== -1
          || peopleDetails?.isMember && el.songDetails?.arrangement?.indexOf('one_ok_rock') !== -1)
        .map((el) => getSongAllDetails(el));

      const songArtProduction = songsData
        .filter((el) => el.songDetails?.production?.indexOf(peopleId) !== -1)
        .map((el) => getSongAllDetails(el));

      return {
        ...state,
        ...initialStateDefault,
        peopleDetails: {
          ...peopleDetails,
          name: peopleName
        },
        songArt: {
          ...initialStateDefault,
          lyrics: songArtLyrics,
          music: songArtMusic,
          arrangement: songArtArrangement,
          production: songArtProduction
        }
      };
    }
  }
});

export const { getPeopleDetails } = peopleSlice.actions;

export default peopleSlice.reducer;
